import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CoffeeMakerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"coffee_maker"}/>
}
